module.exports = __webpack_public_path__ + "media/72.a7b5eccf.mp3";